import * as React from 'react';
import { continueGetDataFromParentWindow } from '../utils/getDataFromParentWindow';
import { getStore } from '../store/childStore';
import { isFeatureEnabled } from 'owa-feature-flags';
import { observer } from 'mobx-react';
import { PopoutChildState } from '../store/schema/PopoutChildStore';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';

export interface PopoutLoadingViewProps {
    loadingString: string;
}

const styles = require('./PopoutLoadingView.scss');

@observer
export default class PopoutLoadingView extends React.Component<PopoutLoadingViewProps, {}> {
    componentDidMount() {
        if (!isFeatureEnabled('rp-popoutsDebug')) {
            this.loadData();
        }
    }

    render() {
        return (
            <div className={styles.view}>
                {getStore().state == PopoutChildState.Loading
                    ? this.renderSpinner()
                    : this.renderDebugButton()}
            </div>
        );
    }

    private renderDebugButton() {
        // This UI is only visible when rp-popoutsDebug flight is enabled, and is used for debugging only,
        // so no need to be localized
        return <button onClick={this.loadData}>Get Data</button>;
    }

    private renderSpinner() {
        return (
            <span>
                <Spinner />
                {this.props.loadingString}
            </span>
        );
    }

    private loadData = () => {
        continueGetDataFromParentWindow();
    };
}
